<template>
  <div class="inheritor">
    <!-- <img src="@/assets/images/detail/culturalCollection/landscape.png" alt="" class="top_bg" /> -->
    <div class="navbar-top">
      <div class="navbar-div"></div>
      <div class="navbar">
        <span>传承人详情</span>
        <img src="@/assets/images/detail/back.png" alt="" class="back" @click="back" />
      </div>
    </div>
    <div class="content">
      <div class="information d-f jc-sb ai-c">
        <div class="d-f ai-c">
          <img :src="detailInfo.picUrl" alt="" class="profile_photo" />
          <div class="d-f fxd-c">
            <div class="name">{{ detailInfo.name }}</div>
            <div class="tags d-f ai-c">
              <div class="tag_item" v-if="detailInfo.levelName">{{ detailInfo.levelName }}</div>
              <div class="tag_item">{{ detailInfo.typeName }}</div>
            </div>
            <!-- <div class="address">区域：{{ detailInfo.areaName }}</div> -->
          </div>
        </div>
        <div class="right_total">
          <div class="d-f fxd-c ai-c jc-sb">
            <span>{{ detailInfo.followNum }}</span>
            <span>粉丝数</span>
          </div>
          <!-- <div @click="handleFollow">
            <div class="attention d-f ai-c" v-if="!detailInfo.isFollow">
              <img src="@/assets/images/detail/culturalCollection/attention.png" alt="" class="add_icon" />
              <span>关注</span>
            </div>
            <div class="attention active" v-else>
              <span>已关注</span>
            </div>
          </div> -->
        </div>
      </div>
      <div class="address_box d-f ai-c jc-sb">
        <div class="address">区域：{{ detailInfo.areaName }}</div>
        <div @click="handleFollow">
          <div class="attention d-f ai-c" v-if="!detailInfo.isFollow">
            <img src="@/assets/images/detail/culturalCollection/attention.png" alt="" class="add_icon" />
            <span>关注</span>
          </div>
          <div class="attention active" v-else>
            <span>已关注</span>
          </div>
        </div>
      </div>
      <div>
        <div class="common_title">传承人简介</div>
        <div class="intro_content" v-html="detailInfo.detail"></div>
      </div>
      <div v-if="projectList.length > 0">
        <div class="common_title">传承项目</div>
        <div class="d-f ai-c project_item" v-for="item in projectList" @click="godetail(item.id)">
          <img :src="item.picUrl" alt="" class="project_img" />
          <div>
            <div class="title">{{ item.name }}</div>
            <div class="tags d-f ai-c">
              <div class="tag_item">{{ item.levelName }}</div>
              <div class="tag_item">{{ item.typeName }}</div>
            </div>
            <div class="project_content" v-html="item.detail"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getichPersonInfoDetails, getIchProjectByPersonId } from '@/api/intangibleCultural'
import { submitUserFollow, cancelFollow } from '@/api/operation'
import { getToken, getVenueToken } from '@/utils/auth'

export default {
  name: 'inheritor',
  data() {
    return {
      id: '',
      detailInfo: {},
      projectList: [],
      from: '',
    }
  },
  methods: {
    back() {
      if (this.from) {
        this.$myUni.postMessage({
          data: {
            methodsName: 'UNIBack',
          },
        })
        // this.$myUni.navigateBack({
        //   delta: 1,
        // })
      } else {
        this.$router.go(-1)
      }
    },
    removeHtmlTags(msg) {
      var msg = msg.replace(/<[^>]+>|&[^>]+;/g, '') //去除HTML Tag
      msg = msg.replace(/[|]*n/, '') //去除行尾空格
      msg = msg.replace(/&npsp;/gi, '') //去掉npsp
      return msg
    },
    getDetail() {
      getichPersonInfoDetails(this.id).then((res) => {
        this.detailInfo = res.result
      })
    },
    godetail(id) {
      console.log('sss')
      this.$router.push({
        path: '/detail/extrageneticDirectories',
        query: {
          id: id,
        },
      })
    },
    getProject() {
      getIchProjectByPersonId(this.id).then((res) => {
        this.projectList = res.result
        this.projectList.forEach((item) => {
          item.detail = this.removeHtmlTags(item.detail)
        })
        console.log('改过的数据=============》', this.projectList)
      })
    },
    handleFollow() {
      if (!getToken()) {
        this.$myUni.postMessage({
          data: {
            methodsName: 'UNIPage',

            data: {
              id: this.id,
              url: '/detail/inheritor',
              needLocation: false,
            },
          },
        })
        return
      }
      if (!this.detailInfo.isFollow) {
        // 关注
        submitUserFollow({ type: 4, basicId: this.id }).then((res) => {
          if (res.code == 2000) {
            this.getDetail()
          }
        })
      } else {
        // 取消关注
        cancelFollow({ type: 4, basicId: this.id }).then((res) => {
          if (res.code == 2000) {
            this.getDetail()
          }
        })
      }
    },
  },
  mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id
    } else {
      const data = JSON.parse(this.$route.query.params)
      this.id = data.id
      this.from = 'app'
    }
    this.getDetail()
    this.getProject()
  },
}
</script>
<style lang="scss" scoped>
.inheritor {
  width: 100%;
  height: 100vh;
  // background: #f4fcfc;
  background: #ffffff;
  position: relative;

  .tag_item {
    font-size: 0.6rem;
    padding: 0 0.3rem;
    // color: #47988aff;
    color: #a97048;

    height: 0.9rem;
    line-height: 0.9rem;
    // background: rgba(71, 152, 138, 0.15);

    background: #f9eddc;
    border-radius: 2px;
    margin: 0.3rem 0.4rem 0.4rem 0;
  }
  .top_bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 12rem;
  }
  .navbar-top {
    z-index: 10;
    width: 100%;
    height: 84px;
    position: fixed;
    background-color: #ffffff;
    top: 0;
    left: 0;
    .navbar-div {
      width: 100%;
      height: 40px;
    }
    .navbar {
      z-index: 10;
      width: 100%;
      height: 44px;
      // position: fixed;
      // top: 40px;
      // top: calc(40px + env(safe-area-inset-top));
      // left: 0;
      text-align: center;
      line-height: 44px;
      font-weight: 600;
      color: #112a26;
      font-size: 0.9rem;
      background-color: #ffffff;
      .back {
        position: absolute;
        width: 0.6rem;
        height: 1.2rem;
        left: 0.8rem;
        top: 2.5rem;
      }
    }
  }

  .content {
    width: 100%;
    height: calc(100% - 84px);
    // height: calc(100% - 44px - 40px - env(safe-area-inset-top));
    position: absolute;
    // top: calc(44px + 40px + env(safe-area-inset-top));
    top: 84px;
    left: 0;
    padding: 0.7rem 0.6rem 0 0.6rem;
    padding-bottom: calc(0.6rem + env(safe-area-inset-bottom));
    .address_box {
      margin-left: 3.35rem;
      .address {
        font-size: 0.65rem;
        color: #666666;
        line-height: 0.9rem;
      }
      .attention {
        // margin-top: 0.85rem;
        font-size: 0.5rem;
        color: #ffffff;
        line-height: 0.6rem;
        padding: 0 0.4rem;
        height: 1.1rem;
        line-height: 1.1rem;
        // background: #47988a;

        background: #a97048;
        border-radius: 0.7rem;
        &.active {
          // color: #47988a;
          color: #a97048;
          background-color: rgba(0, 0, 0, 0);
          border: 1px solid #a97048;
        }
        .add_icon {
          width: 0.5rem;
          height: 0.5rem;
          margin-right: 4px;
        }
      }
    }
    .information {
      // margin-bottom: 1.2rem;
      // margin-bottom: 0.3rem;
      .profile_photo {
        // width: 3rem;
        // height: 3rem;
        width: 2.8rem;
        height: 2.8rem;
        border-radius: 0.4rem;

        // border-radius: 3rem;
        margin-right: 0.55rem;
      }
      .name {
        font-size: 0.9rem;
        font-weight: 600;
        color: #212121;
        line-height: 1.4rem;
      }
      // .address {
      //   font-size: 0.65rem;
      //   color: #666666;
      //   line-height: 0.9rem;
      // }
      .right_total {
        height: 100%;
        font-size: 0.6rem;
        color: #666666;
        line-height: 0.8rem;
        // .attention {
        //   margin-top: 0.85rem;
        //   font-size: 0.5rem;
        //   color: #ffffff;
        //   line-height: 0.6rem;
        //   padding: 0 0.4rem;
        //   height: 1.1rem;
        //   line-height: 1.1rem;
        //   // background: #47988a;

        //   background: #a97048;
        //   border-radius: 0.7rem;
        //   &.active {
        //     // color: #47988a;
        //     color: #a97048;
        //     background-color: rgba(0, 0, 0, 0);
        //     border: 1px solid #a97048;
        //   }
        //   .add_icon {
        //     width: 0.5rem;
        //     height: 0.5rem;
        //     margin-right: 4px;
        //   }
        // }
      }
    }
    .common_title {
      font-size: 0.8rem;
      font-weight: 600;
      color: #212121;
      line-height: 1.2rem;
      margin-bottom: 0.6rem;
    }
    .intro_content {
      font-size: 0.7rem;
      color: #666666;
      line-height: 1rem;
      margin-bottom: 1.2rem;
    }
    .project_img {
      width: 6.4rem;
      height: 4.8rem;
      border-radius: 0.5rem;
      margin-right: 0.6rem;
    }
    .title {
      font-size: 0.7rem;
      font-weight: 600;
      color: #212121;
      line-height: 1rem;
    }
    .project_item {
      margin-bottom: 0.6rem;
    }
    .project_content {
      font-size: 0.6rem;
      color: #666666;
      line-height: 0.8rem;
      overflow: hidden; //溢出隐藏
      white-space: pre-wrap;
      text-overflow: ellipsis; //省略号
      display: -webkit-box; //
      -webkit-box-orient: vertical; //设置弹性盒子的子元素的排列方式
      -webkit-line-clamp: 3; //设置显示文本的行数
    }
  }
}
</style>
